export const Comuni = [
	{
		key: "Lecce",
		value: "Lecce",
	},
	{
		key: "Maglie",
		value: "Maglie",
	},
	{
		key: "Galatina",
		value: "Galatina",
	},
	{
		key: "Gallipoli",
		value: "Gallipoli",
	},
	{
		key: "San Cesario di Lecce",
		value: "San Cesario di Lecce",
	},
];

export const Settori = [
	{
		key: "",
		value: "",
	},
	{
		key: "Agricoltrura",
		value: "Agricoltrura",
	},
	{
		key: "Artigianato",
		value: "Artigianato",
	},
	{
		key: "Commercio",
		value: "Commercio",
	},
	{
		key: "ComproOro",
		value: "Compro oro",
	},
	{
		key: "CreditoFinanza",
		value: "Credito/Finanza",
	},
	{
		key: "Edilizia",
		value: "Edilizia",
	},
	{
		key: "GestioneCase",
		value: "Gestione case da gioco",
	},
	{
		key: "Industria",
		value: "Industria",
	},
	{
		key: "MoneyTransfer",
		value: "Money Transfer",
	},
	{
		key: "PubblicaAmministrazione",
		value: "Pubblica Amministrazione",
	},
	{
		key: "Servizi",
		value: "Servizi",
	},
	{
		key: "Turismo",
		value: "Turismo",
	},
	{
		key: "AttivitaNoProfit",
		value: 'Attività "no profit"',
	},
	{
		key: "Altro",
		value: "Altro",
	},
];
